import React from 'react';

const LoadingPage: React.FC = () => {
	return (
		<div className='loading-page-container'>
			<div className='loading-page-spinner'></div>
			<p className='loading-page-text'>Loading, please wait...</p>
		</div>
	);
};

export default LoadingPage;
